import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";

const Attributes = {
  formSize: "lg",
  enableAddButton: true,
  settingsMode: false,
  enableAdvanceSearch: true,
  modes: [],
};

const operationURLS = {
  create: "/operator/create",
  update: "/operator/update",
  list: "operator/list",
  delete: "operator/delete",
};


const getColumns = (onDelete, onEdit,editCode) => {

  return [
    {
      Header: "Operator code",
      accessor: "operatorcode",
      disabled:editCode?true:false,
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      options: {
        keyField: "username",
        keyDescription: "username",
        values: [],
        url: "/operator/users/role/ocadmin",
      },
    },
    {
      Header: "ACD Group",
      accessor: "landingextension",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "extensionNo",
        keyDescription: "extensionNo",
        values: [],
        url: "/operator/extensions/ocgroup",
      },
    },
    {
      Header: "Answer Station",
      accessor: "as",
      displayInList: true,
      allowInForm: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,
      options: {
        keyField: "extensionNumber",
        keyDescription: "extensionNumber",
        values: [],
        url: "/operator/extensions/phone",
      },
    },
    {
      Header: "Answer Trunk",
      accessor: "at",
      displayInList: true,
      allowInForm: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,
      options: {
        keyField: "extensionNumber",
        keyDescription: "extensionNumber",
        values: [],
        url: "/operator/extensions/phone",
      },
    },
    {
      Header: "Answer VIP",
      accessor: "av",
      displayInList: true,
      allowInForm: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,

      options: {
        keyField: "extensionNumber",
        keyDescription: "extensionNumber",
        values: [],
        url: "/operator/extensions/phone",
      },
    },
    {
      Header: "Answer Base",
      accessor: "ab",
      displayInList: true,
      allowInForm: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,
      options: {
        keyField: "extensionNumber",
        keyDescription: "extensionNumber",
        values: [],
        url: "/operator/extensions/phone",
      },
    },
    {
      Header: "Serial Call",
      accessor: "sc",
      displayInList: true,
      allowInForm: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,
      options: {
        keyField: "extensionNumber",
        keyDescription: "extensionNumber",
        values: [],
        url: "/operator/extensions/phone",
      },
    },
    {
      Header: "Operator Extension",
      accessor: "extension",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "extensionNumber",
        keyDescription: "extensionNumber",
        values: [],
        url: "/operator/extensions/phone",
      },
    },
    {
      Header: "Operator Mode",
      accessor: "operatormode",
      displayInList: true,
      allowInForm: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          {
            id: "With Headphone",
            description: "With Headphone",
          },
          { id: "Without Headphone", description: "Without Headphone" },
        ],
      },
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
